import React, { Fragment } from 'react';
import classnames from 'classnames';
import Icon, { IconType } from '../icon';
import HeaderVariant from './variant';
import HeaderExpand from './expand';
import styles from './style.less';

export interface HeaderProps {
  className?: string;
  price?: string;
  title?: string;
  onClose: () => void;
  closeIconType?: IconType;
  closeIconColor?: string;
  renderContent?: React.ReactNode;
  renderSubmit?: React.ReactNode;
  style?: React.CSSProperties;
}

export interface HeaderState {}

class Header extends React.Component<HeaderProps, HeaderState> {

  static Variant: typeof HeaderVariant;
  static Expand: typeof HeaderExpand;

  constructor(props: HeaderProps) {
    super(props);
  }

  render() {
    const { price = '', title = '', closeIconType = 'close', className, closeIconColor = '#ff0136', onClose, renderContent, renderSubmit, style } = this.props;
    return (
      <div
        className={classnames(styles.header, className, {
          [styles.headerHasSubmit]: !!renderSubmit
        })}
        style={style}
      >
        <div
          id="sunzi-header-close"
          className={classnames(styles.headerClose, 'sunzi-header-close')}
          onClick={onClose}
        >
          <Icon type={closeIconType} color={closeIconColor} size={30} />
        </div>
        <div className={classnames(styles.headerContent, 'sunzi-header-content')}>
          {renderContent || (
            <Fragment>
              <div
                className={classnames(styles.headerContentPrice, 'sunzi-header-price')}
                dangerouslySetInnerHTML={{ __html: price }}
              />
              <div className={styles.headerContentTitle}>
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </div>
            </Fragment>
          )}
        </div>
        <div className={styles.headerSubmit}>
          {renderSubmit}
        </div>
      </div>
    );
  }
}

Header.Variant = HeaderVariant;
Header.Expand = HeaderExpand;

export default Header;
